import React from "react";

export const Card = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`h-full bg-white lg:px-4 lg:pb-3 lg:pt-3 rounded-md lg:shadow-lg overflow-x-auto ${className}`}>
      {children}
    </div>
  );
};
